import { BottomSheetModalProvider } from '@gorhom/bottom-sheet';
import { BottomSheetMobile } from '@photosi/rn-components/bottom-sheet-provider/bottom-sheet-mobile/BottomSheetMobile';
import { useIsFocused } from '@react-navigation/native';
import { PropsWithChildren } from 'react';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

export const BottomSheetProvider = ({ children }: PropsWithChildren) => {
  const { isDesktop } = useResponsiveScreen();
  const isFocused = useIsFocused();

  return !isDesktop && isFocused ? (
    <BottomSheetModalProvider>
      {children}
      <BottomSheetMobile />
    </BottomSheetModalProvider>
  ) : (
    children
  );
};
